import _ from 'underscore';
import { mapState } from 'vuex';
import paymentpreview from '../preview/index.vue'
import JsonViewer from 'vue-json-viewer'

export default {
	name: 'payment_payment',
	props: {
		payment : Object
	},

	components : {
		paymentpreview,
		JsonViewer
	},

	data : function(){

		return {}

	},

	created() {
		

	},

	destroyed() {
	},

	watch: {
		
	},
	computed: mapState({
		
		auth : state => state.auth
	}),

	methods : {

		
	},
}